import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  display: ${({ load }) => (load ? 'block' : 'none')};
  z-index: 9999;
`;
